import { render } from "./Sanchan1.vue?vue&type=template&id=a9337670&scoped=true"
import script from "./Sanchan1.vue?vue&type=script&lang=js"
export * from "./Sanchan1.vue?vue&type=script&lang=js"

import "./Sanchan1.vue?vue&type=style&index=0&id=a9337670&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-a9337670"

export default script